module.exports = __webpack_public_path__ + "public/StoreIcon/view-icon.svg?16865f19";